import { ContentPluginRootState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const getActiveGroup = (state: ContentPluginRootState) => state.data.activeGroup;

export default getActiveGroup;
